export enum TestRequestCreateOperation {
    NEW = 0,
    COPY = 1,
}